'use client';
import { use } from 'react';
import { HeaderUIStateContext } from '@/components/header/header_menu/HeaderUIStateProvider';
import Link from 'next/link';
import { useModal, MODAL_TYPES } from '@/components/modal/ModalProvider';
import ExternalLink from '@/components/elements/ExternalLink';
import Cookies from 'js-cookie';

export default function UtilityNav({ data }) {
  const { showUtility } = use(HeaderUIStateContext);
  const { showModal } = useModal();
  const {
    callout_link,
    callout_primary_copy,
    callout_secondary_copy,
    disclaimer_button_copy,
    disclaimer_content,
    links
  } = data;
  const isAuthenticated = Boolean(Cookies.get('custaccesstoken'));

  function openUtilityNavModal(e) {
    e.preventDefault();
    e.stopPropagation();

    showModal(MODAL_TYPES.utilityNav, {
      promoDisclaimer: disclaimer_content[0]?.campaign_terms
    });
  }

  return (
    <section
      id={'utility-nav'}
      data-name={'utility-nav'}
      className={`bg-parlor-green-115 fixed z-60 min-h-12 w-screen transform text-white transition-transform duration-300 ${showUtility ? 'translate-y-0' : '-translate-y-[49px]'}`}
      title="Information Banner"
      data-cy="utility-nav"
    >
      <div className="mx-auto flex min-h-12 max-w-420 items-center justify-between px-10 align-middle lg:px-20">
        <div className="justify-center text-center max-[1024px]:mx-auto">
          <Link href={callout_link[0]?.url} prefetch={false}>
            {callout_primary_copy && (
              <span className="body-s lg:body-r inline-block">
                {callout_primary_copy}
              </span>
            )}
            {callout_secondary_copy && (
              <span className="sh12 lg:sh11 ml-1 inline-block">
                {callout_secondary_copy}
              </span>
            )}
          </Link>
          {disclaimer_button_copy && disclaimer_content && (
            <span className="body-xs ml-2 inline-block">
              <button
                className="expanded-hitbox hover:text-parlor-green-30 relative underline"
                onClick={(e) => openUtilityNavModal(e)}
                modal-toggler="true"
                data-cy="utility-nav-disclaimer"
              >
                {disclaimer_button_copy}
              </button>
            </span>
          )}
        </div>
        <div className="hidden lg:block">
          {links.map((link, index) => {
            const isAccountLink =
              link.internal_link?.[0]?.url?.startsWith('/account');
            const accountRedirect = isAuthenticated
              ? '/account'
              : '/account/auth/login';

            if (link.link_type == 'Internal') {
              const href = isAccountLink
                ? accountRedirect
                : `${link.internal_link[0].url}${link.query_string}`;
              const className =
                'body-s hover:text-parlor-green-30 [&:not(:last-child)]:pr-5';
              const dataCy = isAccountLink
                ? 'header-account-link'
                : 'header-support-link';

              if (isAccountLink && !isAuthenticated) {
                return (
                  <a
                    key={index}
                    href={href}
                    className={className}
                    data-cy={dataCy}
                  >
                    {link.link_copy}
                  </a>
                );
              }

              return (
                <Link
                  key={index}
                  href={href}
                  prefetch={false}
                  className={className}
                  data-cy={dataCy}
                >
                  {link.link_copy}
                </Link>
              );
            } else {
              return (
                <ExternalLink
                  key={index}
                  externalLink={link.external_link}
                  linkType={link.link_type}
                  linkStyling={`body-s [&:not(:last-child)]:pr-5 hover:text-parlor-green-30`}
                  linkText={link.link_copy}
                  data-cy="header-support-link"
                />
              );
            }
          })}
        </div>
      </div>
    </section>
  );
}
